export const information = {
  site: "jun88k36",
  endpoint: "https://api-jun88k36.freecodevip.org",
  // endpoint: "http://localhost:5039",


  cskh_url: "https://jun88p1cskh01.pages.dev",
  nav_url: "https://77jjun88.com/trangchu",
  key_free: "att.code.hau-dai.jun88-k36@2030$",
};
